import IMAGES from "../../Constants/images";

const FyersLoader = () => (
  <div className="d-flex justify-content-center mt-5">
    <img src={IMAGES.fyers_loader} alt="Loading" width={90} />
  </div>
);

export default FyersLoader;
